var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulaInputField',_vm._g(_vm._b({attrs:{"required":"","data-explorer-loading":_vm.dataExplorerLoading,"data-providers":_vm.dataProviders,"application-context":_vm.applicationContext}},'FormulaInputField',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }